import React, { useState, useEffect } from 'react'

function PopularListTypeInMovies(props) {
  const [popularListType, setPopularListType] = useState('movies')

  const handlepopularListType = value => {
    setPopularListType(value)
  }

  // console.log(props.listData, 'props.listDataprops.listData')
  useEffect(() => {
    const query = window.location.href.split('?')[1]

    if (query) {
      // console.log(
      //   props.listData && props.listData.popularListType,
      //   'props.listData && props.listData.popularListType',
      // )
      setPopularListType(props.listData && props.listData.popularListType)
    }

    // console.log(props.listData, 'listData')
  }, [props.listData])

  // console.log(props.mode, popularListType, 'popularListTypepopularListType')
  return (
    <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
      <label htmlFor='listLimit'>PopularListType</label>
      <div className='d-flex gap-2 mt-2'>
        <div className='d-flex'>
          <input
            onChange={e => props.handleListData('popularListType', e.target.id)}
            onClick={e => handlepopularListType(e.target.id)}
            value={popularListType}
            checked={popularListType === 'movies'}
            type='radio'
            id='movies'
            name='fav_language'
          />
          <p htmlFor='movies'>Movies</p>
        </div>
        <div className='d-flex gap-2'>
          <div className='d-flex gap-1'>
            <input
              onChange={e => props.handleListData('popularListType', e.target.id)}
              value={popularListType}
              onClick={e => handlepopularListType(e.target.id)}
              type='radio'
              checked={popularListType === 'webseries'}
              id='webseries'
              name='fav_language'
            />
            <p htmlFor='webseries'>Webseries</p>
          </div>
        </div>
      </div>{' '}
    </div>
  )
}

export default PopularListTypeInMovies
